import * as React from "react";

type TStudentChoiceCasesListProps = {
  documentSetListForStudentChoiceCases: TDocumentSetListForStudentChoiceCases;
  style?: React.CSSProperties;
  onCheckboxChange?: (courseId: string, checked: boolean) => void;
};

const StudentChoiceCasesList = ({
  documentSetListForStudentChoiceCases,
  style,
  onCheckboxChange,
}: TStudentChoiceCasesListProps) => {
  if (documentSetListForStudentChoiceCases?.length === 0) {
    return null;
  }

  return (
    <div
      className="finish-card-modal--student-choice-cases-list--container"
      style={{
        ...style,
      }}
    >
      <p className="finish-card-modal--student-choice-cases-list--title">
        OPTIONAL: Add to the following course(s) as a student-choice case
      </p>
      {documentSetListForStudentChoiceCases.map(([courseName, courseId]) => {
        const courseIdStr = String(courseId);
        return (
          <div
            className="finish-card-modal--student-choice-cases-list--checkbox-row"
            key={courseIdStr}
          >
            <input
              type="checkbox"
              id={`course-${courseIdStr}`}
              name="courses"
              value={courseIdStr}
              onChange={(e) =>
                onCheckboxChange?.(courseIdStr, e.target.checked)
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const newChecked = !e.currentTarget.checked;
                  e.currentTarget.checked = newChecked;
                  onCheckboxChange?.(courseIdStr, newChecked);
                }
              }}
            />
            <label
              htmlFor={`course-${courseIdStr}`}
              className="finish-card-modal--student-choice-cases-list--label"
            >
              {courseName}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default StudentChoiceCasesList;
